import {
  SMART_EDIT_STATUS_FAILURE,
  SMART_EDIT_STATUS_LOADING,
  SMART_EDIT_STATUS_REQUEST,
  SMART_EDIT_STATUS_SUCCESS,
  SMART_EDIT_TOP_CLAIM_FAILURE,
  SMART_EDIT_TOP_CLAIM_LOADING,
  SMART_EDIT_TOP_CLAIM_REQUEST,
  SMART_EDIT_TOP_CLAIM_SUCCESS,
  SMART_EDIT_TOP_REASONS_FAILURE,
  SMART_EDIT_TOP_REASONS_LOADING,
  SMART_EDIT_TOP_REASONS_REQUEST,
  SMART_EDIT_TOP_REASONS_SUCCESS,
  SMART_EDITS_SUMMARY_FAILURE,
  SMART_EDITS_SUMMARY_LOADING,
  SMART_EDITS_SUMMARY_REQUEST,
  SMART_EDITS_SUMMARY_SUCCESS,
} from '../../actionTypes';
import { 
  SMART_EDIT_OVER_TIMES_REQUEST, 
  SMART_EDIT_OVER_TIMES_SUCCESS, 
  SMART_EDIT_OVER_TIMES_FAILURE, 
  SMART_EDIT_OVER_TIMES_LOADING
} from './sm.ActionTypes';

export const fetchSmartEditsSummaryRequest = (payload: any, showGeoSegView: boolean = false, isHighVolumeTinFlow: boolean = false) => ({
  type: SMART_EDITS_SUMMARY_REQUEST,
  payload: { ...payload, showGeoSegView, isHighVolumeTinFlow },
});

export const fetchSmartEditsSummarySuccess = (payload: any) => ({
  type: SMART_EDITS_SUMMARY_SUCCESS,
  payload,
});

export const fetchSmartEditsSummaryError = (payload: any) => ({
  type: SMART_EDITS_SUMMARY_FAILURE,
  payload,
});

export const fetchSmartEditsSummaryLoading = (payload: any) => ({
  type: SMART_EDITS_SUMMARY_LOADING,
  payload,
});

export const fetchSmartEditStatusRequest = (payload: any, showGeoSegView: boolean = false, isHighVolumeTinFlow: boolean = false) => ({
  type: SMART_EDIT_STATUS_REQUEST,
  payload: { ...payload, showGeoSegView, isHighVolumeTinFlow },
});

export const fetchSmartEditStatusSuccess = (payload: any) => ({
  type: SMART_EDIT_STATUS_SUCCESS,
  payload,
});

export const fetchSmartEditStatusError = (payload: any) => ({
  type: SMART_EDIT_STATUS_FAILURE,
  payload,
});

export const fetchSmartEditStatusLoading = (payload: any) => ({
  type: SMART_EDIT_STATUS_LOADING,
  payload,
});

export const fetchSmartEditTopReasonsRequest = (payload: any, showGeoSegView: boolean = false, isHighVolumeTinFlow: boolean = false) => ({
  type: SMART_EDIT_TOP_REASONS_REQUEST,
  payload: { ...payload, showGeoSegView, isHighVolumeTinFlow },
});

export const fetchSmartEditTopReasonsSuccess = (payload: any) => ({
  type: SMART_EDIT_TOP_REASONS_SUCCESS,
  payload,
});

export const fetchSmartEditTopReasonsError = (payload: any) => ({
  type: SMART_EDIT_TOP_REASONS_FAILURE,
  payload,
});

export const fetchSmartEditTopReasonsLoading = (payload: any) => ({
  type: SMART_EDIT_TOP_REASONS_LOADING,
  payload,
});

export const fetchSmartEditOverTimesRequest = (payload: any, showGeoSegView: boolean = false, isHighVolumeTinFlow: boolean = false) => ({
  type: SMART_EDIT_OVER_TIMES_REQUEST,
  payload: { ...payload, showGeoSegView, isHighVolumeTinFlow },
});

export const fetchSmartEditOverTimesSuccess = (payload: any) => ({
  type: SMART_EDIT_OVER_TIMES_SUCCESS,
  payload,
});

export const fetchSmartEditOverTimesError = (payload: any) => ({
  type: SMART_EDIT_OVER_TIMES_FAILURE,
  payload,
});

export const fetchSmartEditOverTimesLoading = (payload: any) => ({
  type: SMART_EDIT_OVER_TIMES_LOADING,
   payload,
});
export const fetchSmartEditTopClaimRequest = (payload: any) => ({
  type: SMART_EDIT_TOP_CLAIM_REQUEST,
  payload,
});

export const fetchSmartEditTopClaimSuccess = (payload: any) => ({
  type: SMART_EDIT_TOP_CLAIM_SUCCESS,
  payload,
});

export const fetchSmartEditTopClaimError = (payload: any) => ({
  type: SMART_EDIT_TOP_CLAIM_FAILURE,
  payload,
});

export const fetchSmartEditTopClaimLoading = (payload: any) => ({
  type: SMART_EDIT_TOP_CLAIM_LOADING,
  payload,
});